(function () {
  var observer;
  var frameRequested = false;

  function findRating(productForm) {
    return productForm.querySelector(
      '.jdgm-widget.jdgm-preview-badge, .jdgm-preview-badge'
    );
  }

  function positionJudgeMeRating() {
    document
      .querySelectorAll('[data-product-form-wrapper]')
      .forEach(function (productForm) {
        var rating = findRating(productForm);
        var target = productForm.querySelector(
          '.product__block__remaining .product__button__meta'
        );

        if (!rating || !target) return;

        if (rating.parentNode !== target) {
          target.appendChild(rating);
        }
      });
  }

  function schedulePositioning() {
    if (frameRequested) return;
    frameRequested = true;

    window.requestAnimationFrame(function () {
      frameRequested = false;
      positionJudgeMeRating();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedulePositioning);
  } else {
    schedulePositioning();
  }

  observer = new MutationObserver(schedulePositioning);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();